import React, { useEffect } from 'react';
import io from 'socket.io-client';

export default ({ events, rooms, onEmit }) => {
    const url = {
        production: null,
        development: null,
        local: "http://localhost:8014"
    }
    const env = process.env.NODE_ENV;
    const socket = io(url[env]);
   
    useEffect(() => {
        socket.on('connect', () => {
            socket.emit('subscribe', rooms, (data) => {
                console.log(rooms)
            })
        })

        socket.on(events, data => {
            onEmit(data)
        })

        return () => {
            socket.emit('unsubscribe', rooms)
        }
    })

    return (
        <div></div>
    )
}